import { ObjectIndexer } from "../../../../type-utils"

export enum PaymentSystemType {
    DIRECT = "D",
    CLOUDPAYMENTS = "C",
    YOOKASSA = "Y",
    BANK = "B",
    YOOKASSA_DIRECT = "K",
    YOOKASSA_SAFE = "S",
    STRIPE = "P",
    GAZPROMPAY = "G",
}

export interface PsychologistPayment extends ObjectIndexer<string | number> {
    client_email: string
    client_name: string
    date: string
    fee_amount: number
    id: number
    payment_datetime: string
    psy_revenue: number
    sequence_number: number
    service_name: string
    effective_bank_date: string
    type: PaymentSystemType
    is_post_paid: string
}

export type SortableKeys = Exclude<keyof PsychologistPayment, "type">

export type PsychologistPaymentsGroupedResponse = Record<
    "result" | "pending" | "prior" | "pending_postpaid" | "prior_postpaid",
    PsychologistPayment[]
>
